export const getAllNewsUrl = "/news/getAllNews";
export const createNewsUrl = "/news/createNews";
export const editNewsUrl = "/news/editNews";
export const deleteNewsUrl = "/news/deleteNews/{title}";